module.exports = __webpack_public_path__ + "img/sort-alpha-up.81fd36bd.svg";